import { render, staticRenderFns } from "./PricingPageV2.vue?vue&type=template&id=61ce85e6&scoped=true&"
import script from "./PricingPageV2.vue?vue&type=script&lang=js&"
export * from "./PricingPageV2.vue?vue&type=script&lang=js&"
import style0 from "./PricingPageV2.vue?vue&type=style&index=0&id=61ce85e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce85e6",
  null
  
)

export default component.exports